var map = {
	"./wix-music-widget-0.js": [
		93,
		8
	],
	"./wix-music-widget-1.js": [
		94,
		7
	],
	"./wix-music-widget-2.js": [
		95,
		6
	],
	"./wix-music-widget-3.js": [
		96,
		5
	],
	"./wix-music-widget-4.js": [
		97,
		4
	],
	"./wix-music-widget-5.js": [
		98,
		3
	],
	"./wix-music-widget-6.js": [
		99,
		2
	],
	"./wix-music-widget-7.js": [
		100,
		1
	],
	"./wix-music-widget-8.js": [
		101,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 87;


//////////////////
// WEBPACK FOOTER
// ../~/wix-music-widget/lib lazy ^\.\/wix\-music\-widget\-.*\.js$
// module id = 87
// module chunks = 9